import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HotelService from "../../services/hotel.service";

// Fetch the list of hotels
export const getHotelList = createAsyncThunk(
  "hotel/getHotelList",
  async (item, thunkApi) => {
    try {
      const data = await HotelService.gethotellist(item);
      return { 
        hotels: data?.hotelData || [], 
        total: data?.totalDataCount || 0,
        currentPageCount: data?.currentPageCount || 0
      };
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Failed to fetch hotels.";
      return thunkApi.rejectWithValue({ message });
    }
  }
);

// Fetch the list of places
export const getPlacesList = createAsyncThunk(
  "hotel/getPlacesList",
  async (item, thunkApi) => {
    try {
      const data = await HotelService.getplaceslist(item);
      return { places: data };
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Failed to fetch places.";
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const getsearchsuggestion = createAsyncThunk(
  "hotel/getsearchsuggestion",
  async (item, thunkApi) => {
    try {
      const data = await HotelService.getsearchsuggestion(item);

      //  return suggestions directly
      return data?.suggestions || [];
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch search suggestions.";

      return thunkApi.rejectWithValue(message);
    }
  }
);


// Fetch the list of places
export const getPropertyType = createAsyncThunk(
  "hotel/getPropertyType",
  async (item, thunkApi) => {
    try {
      const data = await HotelService.getPropertyType(item);
      return { propertytype: data };
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Failed to fetch places.";
      return thunkApi.rejectWithValue({ message });
    }
  }
);

// Fetch hotel details
export const getHotelDetails = createAsyncThunk(
  "hotel/getHotelDetails",
  async (item, thunkApi) => {
    try {
      const data = await HotelService.gethotelDetails(item);
      return { hotelDetails: data };
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Failed to fetch hotel details.";
      return thunkApi.rejectWithValue({ message });
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  hotels: [],
  places: [],
  hotelDetails: null,
};

const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  extraReducers: (builder) => {
    builder
      // Fetch hotels
      .addCase(getHotelList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHotelList.fulfilled, (state, action) => {
        state.loading = false;
        state.hotels = action.payload.hotels;
      })
      .addCase(getHotelList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching hotels.";
      })

      // Fetch places
      .addCase(getPlacesList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlacesList.fulfilled, (state, action) => {
        state.loading = false;
        state.places = action.payload.places;
      })
      .addCase(getPlacesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching places.";
      })

      // Fetch hotel details
      .addCase(getHotelDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHotelDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.hotelDetails = action.payload.hotelDetails;
      })
      .addCase(getHotelDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching hotel details.";
      });
  },
});

export default hotelSlice.reducer;
